const hostname = window.location.hostname;
const parts = hostname.split('.');

/** True when running on the real daulton.co domain (not localhost or pages.dev). */
export const IS_PROD = hostname === 'daulton.co' || hostname.endsWith('.daulton.co');

/**
 * On non-prod preview deployments, the active surface can be overridden via
 * sessionStorage. Null on prod or when no override is set.
 */
export const PREVIEW_SURFACE_OVERRIDE = !IS_PROD
  ? sessionStorage.getItem('_previewSurface')
  : null;

/**
 * The subdomain portion of the current hostname, or null for the root domain.
 *   wexford.daulton.co  → 'wexford'
 *   teldire.daulton.co  → 'teldire'
 *   resume.daulton.co   → 'resume'
 *   daulton.co          → null
 *   wexford.localhost   → 'wexford'  (local dev)
 *   teldire.localhost   → 'teldire'  (local dev)
 *   localhost           → null       (local dev, main site)
 *   abc123.pages.dev    → null unless sessionStorage override is active
 */
export const SUBDOMAIN = (() => {
  // Preview deployments: sessionStorage override takes priority over hostname.
  // 'main' is the sentinel for "user explicitly chose the main site" — map it to null.
  if (PREVIEW_SURFACE_OVERRIDE && PREVIEW_SURFACE_OVERRIDE !== 'main') return PREVIEW_SURFACE_OVERRIDE;
  // Production subdomains: brief.daulton.co → 'brief'
  if (hostname.endsWith('.daulton.co')) return parts[0];
  // Local dev subdomains: brief.localhost → 'brief'
  if (parts.length === 2 && parts[1] === 'localhost') return parts[0];
  return null;
})();

/**
 * Returns the correct href for a given subdomain.
 * Production: full https URL (e.g. https://wexford.daulton.co).
 * Dev/localhost: local path (e.g. /wexford) so the dev server still works.
 *
 * @param {string|null} subdomain - e.g. 'wexford', 'teldire', 'resume', or null for root
 */
export function subdomainHref(subdomain) {
  if (IS_PROD) {
    return subdomain ? `https://${subdomain}.daulton.co` : 'https://daulton.co';
  }
  return subdomain ? `/${subdomain}` : '/';
}
